import { Drawer, Title, Stack, SimpleGrid, Button, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { PageRoutes } from '../../constants/routes';
import {
  IconBell,
  IconCreditCard,
  IconDeviceLaptop,
  IconEyeSearch,
  IconLock,
  IconLogout,
  IconTemplate,
  IconUser,
} from '@tabler/icons-react';
import { ActionTile } from './ActionTile';
import { useApp } from '../../context/AppContext';

interface QuickActionsMenuProps {
  opened: boolean;
  onClose: () => void;
}

export const QuickActionsMenu = ({
  opened,
  onClose,
}: QuickActionsMenuProps) => {
  const { logout, profile } = useApp();
  const navigate = useNavigate();

  const handleProfile = () => {
    navigate(`${PageRoutes.PROFILE}?professionalId=${profile?.id}`);
    onClose();
  };

  const handleChangePassword = () => {
    navigate('/change-password');
    onClose();
  };

  const handleNotificationSettings = () => {
    navigate(PageRoutes.NOTIFICATION_SETTINGS);
    onClose();
  };

  const handlePrivacyPolicy = () => {
    window.open('https://circlebe.com/privacy-policy', '_blank');
    onClose();
  };

  const handleTermsConditions = () => {
    window.open('https://circlebe.com/terms-and-conditions', '_blank');
    onClose();
  };

  const handleTermsOfUse = () => {
    window.open('https://circlebe.com/terms-of-use', '_blank');
    onClose();
  };

  const handlePayments = () => {
    navigate('/payment-history');
    onClose();
  };

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      position="top"
      offset={4}
      radius={'lg'}
      size={495}
    >
      <Stack align="center" w={'100%'}>
        <Title order={3} fw={'normal'}>
          Quick Actions
        </Title>
        <SimpleGrid cols={3}>
          <ActionTile
            icon={<IconLogout />}
            title="Log out"
            onClick={logout}
            testId="quick-actions-logout"
          />
          <ActionTile
            icon={<IconLock />}
            title="Change Password"
            onClick={handleChangePassword}
            testId="quick-actions-change-password"
          />
          <ActionTile
            icon={<IconBell />}
            title="Notifications Settings"
            onClick={handleNotificationSettings}
            testId="quick-actions-notifications"
          />
          <ActionTile
            icon={<IconUser />}
            title="My Profile"
            onClick={handleProfile}
            testId="quick-actions-profile"
          />
          <ActionTile
            icon={<IconCreditCard />}
            title="Payments"
            onClick={handlePayments}
            testId="quick-actions-payments"
          />
          <ActionTile
            icon={<IconEyeSearch />}
            title="Privacy Policy"
            onClick={handlePrivacyPolicy}
            testId="quick-actions-privacy-policy"
          />
          <ActionTile
            icon={<IconDeviceLaptop />}
            title="Terms of Service"
            onClick={handleTermsOfUse}
            testId="quick-actions-terms-of-service"
          />
          <ActionTile
            icon={<IconTemplate />}
            title="Terms & Conditions"
            onClick={handleTermsConditions}
            testId="quick-actions-terms-and-conditions"
          />
        </SimpleGrid>
        <Button variant="outline" color="black" w={'325'} onClick={onClose}>
          Close
        </Button>
        <Text size="xs" c="dimmed" data-testid="quick-actions-version">
          v{__APP_VERSION__}
        </Text>
      </Stack>
    </Drawer>
  );
};
